/* eslint-disable no-lonely-if */
/* eslint-disable no-unused-expressions */
/* eslint-disable max-len */
/* eslint-disable no-param-reassign */
/* eslint-disable no-plusplus */
/* eslint-disable no-alert */
/* eslint-disable no-tabs */
import _ from 'lodash';
import '../../../assets/css/pages/product.css';
import api from '../../utils/api';
import { API_BASE_URL, LOAD_BASE_URL } from '../../../config';
import {
  setCookie, setRallyClose, getRallyClose, serverDate, isInput, bestRecordValiChk,
  checkRequired, emailChange, birthList, today, courseSeqArr, payTenStart, payFullStart,
  setupAddressMapKakao, noRecordCheck, checkLength, showSucces, checkEmail,
  toggleDisplay, calcPrice, validationArr, payFullEnd, payTenEnd, Mobile,
  setValidationArr, validateFile, recordFirstStart, recordFirstEnd, recordSecondStart, recordSecondEnd,
  payEarlyFullStart, payEarlyFullEnd, payEarlyTenStart, payEarlyTenEnd, checkPasswordConf, busPeriodStart, busPeriodEnd,
} from '../../utils/common';
import { errorMessage } from '../../utils/message';

let infoObj = ''; // 참가 신청자 데이터 배열
let dataCheckPw = null; // 변경할 비밀번호 변수
let changeBloodConf = ''; // 변경할 혈액형 변수
const nationDivide = 'local'; // validation 국가 언어 지정
let receiveTypeEn = 'C'; // 물품 수령방법 데이터
let subsYn = ''; // 무료구독 동의 여부 데이터
let groupSeq;
let formdata = new FormData();
let uuid;
const uploadModal = document.querySelector('.upload_form');
const cancelModal = document.querySelector('.confirm-modal');
const confirmModal = document.querySelector('.confirm-modal');
const subsModal = document.querySelector('.subs-modal');
const busModal = document.querySelector('.bus-modal');

const name = document.getElementById('name');
const confirmEndDate = new Date('2026-09-23T17:59:59'); // 정보 수정/환불하기 기간 설정
const username = document.getElementById('username');
const userenname = document.getElementById('user_en_name');
const year = document.getElementById('year');
const month = document.getElementById('month');
const day = document.getElementById('day');
const password = document.getElementById('password');
const changePasswordConf = document.getElementById('changePasswordConf');
const freecode = document.getElementById('free_code');
const file = document.getElementById('file');
const subscribe = document.getElementById('subscribe');
const nationality = document.getElementById('nationality');
const birth = document.getElementById('birth');
const particle = document.getElementById('particle');
const gender = document.getElementById('gender');
const blood = document.getElementById('blood');
const size = document.getElementById('size');
const email = document.getElementById('email');
const phoneNumber = document.getElementById('phoneNumber');
const emerNumber = document.getElementById('emerNumber');
const subsMail = document.getElementById('subsMail');
const subsMailForm = document.getElementById('subsMailForm');

const changeUsername = document.getElementById('changeUsername');
const changeUserEnName = document.getElementById('changeUserEnName');
const changePassword = document.getElementById('changePassword');
const changeSubscribe = document.getElementById('changeSubscribe');
const changePhoneNumber = document.getElementById('changePhoneNumber');
const changeEmerNumber = document.getElementById('changeEmerNumber');
const changeEmail = document.getElementById('changeEmail');
const changeEmailBehind = document.getElementById('changeEmailBehind');
const changeEmailBehindSelect = document.getElementById('changeEmailBehindSelect');
const changePost = document.getElementById('changePost');
const changeAddressKakao = document.getElementById('changeAddressKakao');
const changeAddressDetail = document.getElementById('changeAddressDetail');
const changeBlood = document.getElementById('changeBlood');
const changeBloodEtc = document.getElementById('changeBloodEtc');
const changeBestHour = document.getElementById('changeBestHour');
const changeBestMin = document.getElementById('changeBestMin');
const changeBestSec = document.getElementById('changeBestSec');
const changeBestDate = document.getElementById('changeBestDate');
const changeBestName = document.getElementById('changeBestName');
const changePickupAddress = document.getElementById('changePickupAddress');
const changeIspayment = document.getElementById('changeIspayment');
const changePayReceipt = document.getElementById('changePayReceipt');
const changePointForm = document.getElementById('changePointForm');

const startGroup = document.getElementById('startGroup');
const particleNumber = document.getElementById('particleNumber');
const pickupAddress = document.getElementById('pickupAddress');
const bestRecord = document.getElementById('bestRecord');
const bestRecordName = document.getElementById('bestRecordName');
const bestRecordDate = document.getElementById('bestRecordDate');
const bestRecordForm = document.getElementById('best-record-form');
const price = document.getElementById('price');
const cancelPrice = document.getElementById('cancelPrice');
const realPrice = document.getElementById('realPrice');
const ispayment = document.getElementById('ispayment');
const kakao = document.getElementById('change_kakao');
const payReceipt = document.getElementById('payReceipt');
const payPayment = document.getElementById('payPayment');
const paySubscribe = document.getElementById('paySubscribe');
const noRecord = document.getElementById('no_record');
const refundBtn = document.getElementById('refund_btn');
const subsBtn = document.getElementById('subs-btn');
const busRefundBtn = document.getElementById('busRefundCancel');
const busPayment = document.getElementById('busPayment');
const pointForm = document.getElementById('pointForm');
const fileName = document.getElementById('file-name');
const fileInput = document.getElementById('file');
// const busCount = document.getElementById('busCount');
// const busCountPay = document.getElementById('busCountPay');

// 각 요소 데이터 삽입
function setUpdateValue(element, value, defaultValue = '-') {
  element.value = value || defaultValue;
}

// 각 요소 개인정보 삽입
function setUpdateText(element, value, defaultValue = '-') {
  element.textContent = value || defaultValue;
}

// 기록증 업로드 기간 버튼 노출
function recordPeriod() {
  if (((today >= recordFirstStart && today <= recordFirstEnd) || (today >= recordSecondStart && today <= recordSecondEnd))) {
    return true;
  }

  return false;
}

function applyDiscount(data) {
  const discounted = data * 0.9;
  return discounted;
}

// 결제 기간 결제버튼 노출
function payPeriod() {
  const isEarly = !!uuid;

  const earlyTenPayPeriod = today >= payEarlyTenStart && today <= payEarlyTenEnd;
  const earlyFullPayPeriod = today >= payEarlyFullStart && today <= payEarlyFullEnd;

  // 10km, full 기간 설정
  const inTenPayPeriod = today >= payTenStart && today <= payTenEnd;
  const inFullPayPeriod = today >= payFullStart && today <= payFullEnd;

  // 10km, full 구분
  const isTenCourse = infoObj.data.data.courseSeq === courseSeqArr.ten.seq || infoObj.data.data.courseSeq === courseSeqArr.tensub.seq;
  const isFullCourse = infoObj.data.data.courseSeq === courseSeqArr.full.seq || infoObj.data.data.courseSeq === courseSeqArr.fullsub.seq;

  const isUnpaid = infoObj.data.data.payState === '0' && !infoObj.data.data.codeNumber;

  const tenPeriod = isEarly ? earlyTenPayPeriod : inTenPayPeriod;
  const fullPeriod = isEarly ? earlyFullPayPeriod : inFullPayPeriod;

  if (isTenCourse) {
    // 10km 코스 판별 후 노출
    return isUnpaid && tenPeriod;
    // eslint-disable-next-line no-else-return
  } else if (isFullCourse) {
    // full 코스 판별 후 노출
    return isUnpaid && fullPeriod;
  } else {
    return true;
  }
}

function addChangeListener(element, callback) {
  if (element) {
    element.addEventListener('change', callback);
  }
}

// 내/외국인 데이터 구별
function updateNationality(data) {
  if (data.nation === 'South Korea') {
    nationality.innerText = '대한민국';
    const select = document.getElementById('change_nationality');
    const option = document.createElement('option');
    option.value = 'South Korea';
    option.textContent = '대한민국';
    select.appendChild(option);
    toggleDisplay('#race_form2', false);
  } else {
    toggleDisplay('#subscribe_form', false);
    toggleDisplay('#choMemberForm', false);
    nationality.innerText = data.nation;
    const select = document.getElementById('change_nationality');
    const option = document.createElement('option');
    option.value = data.nation;
    option.textContent = data.nation;
    select.appendChild(option);
    setCookie('divide_json_data', 'foreigner', 1);

    pickupAddress.innerText = data.receiveType === 'C' ? '개별 수령' : '현장 수령';
  }
}

// 결제 관련 데이터 입력
function updatePayment(data, priceField, cancelField, paymentStatusField, realPriceField) {
  let originPrice = data.price;
  data.point === 5000 ? originPrice -= 5000 : originPrice;
  const calcPriceValue = calcPrice(originPrice);
  priceField.innerText = `${calcPriceValue} 원`;
  // let calcPr = calcPrice(infoObj.data.data.price);
  if (data.payMethod === 'Card') {
    paymentStatusField.innerText = data.payState === '0' ? '미결제' : '신용카드 : 결제완료';
    realPriceField.innerText = data.payState === '0' ? '0 원' : `${calcPriceValue} 원`;
    cancelField.innerText = data.payState === '0' ? '0 원' : `${calcPriceValue} 원`;
  } else if (data.payMethod === 'Coupon') {
    paymentStatusField.innerText = data.payState === '0' ? '미결제' : '결제완료';
    realPriceField.innerText = '0 원';
    cancelField.innerText = '0 원';
    toggleDisplay('.modal_detail_content', false);
  } else {
    paymentStatusField.innerText = data.payState === '0' ? '미결제' : '결제완료';
    realPriceField.innerText = data.payState === '0' ? '0 원' : `${calcPriceValue} 원`;
  }
}

// 신문 구독 데이터 구별
function updateSubscription(data) {
  if (data.subscribeYn === 'Y') {
    toggleDisplay('#free_subForm', true);
    toggleDisplay('#cho_subscribe_form', true);
  }

  if (!data.subscribe) {
    setUpdateText(subscribe, '-');
  } else if (data.subscribe === 'empty') {
    setUpdateText(subscribe, '구독중인 신문 없음');
  } else {
    setUpdateText(subscribe, data.subscribe);
  }
}

// 개인정보 수정 이메일 노출
function updateEmailFields(emailField, emailBehind, emailSelectField) {
  const [emailFront, emailBack] = email.textContent.split('@');
  emailField.value = emailFront;
  emailBehind.value = emailBack;

  let isEmailValid = false;
  for (let i = 0; i < emailSelectField.options.length; i++) {
    if (emailSelectField.options[i].value === emailBack) {
      isEmailValid = true;
      break;
    }
  }

  if (isEmailValid) {
    emailSelectField.value = emailBack;
  } else {
    emailSelectField.value = '';
    emailSelectField.disabled = false;
  }
}

// 개인정보 수정 혈액형 노출
function updateBloodType(data, bloodSelectField, bloodEtcField) {
  let isBloodTypeValid = false;

  for (let i = 0; i < bloodSelectField.options.length; i++) {
    if (bloodSelectField.options[i].value === data.blood) {
      isBloodTypeValid = true;
      break;
    }
  }

  if (isBloodTypeValid) {
    bloodSelectField.value = data.blood;
  } else {
    bloodSelectField.value = 'etc';
    bloodEtcField.disabled = false;
    bloodEtcField.value = data.blood;
  }
}

// 개인정보 수정 최고기록 노출
function updateBestRecord(data) {
  if (data.bestRecord && data.bestRecord !== '00:00:00') {
    const [hour, min, sec] = data.bestRecord.split(':');
    changeBestHour.value = hour;
    changeBestMin.value = min;
    changeBestSec.value = sec;
    changeBestDate.value = data.bestRecordDate;
    changeBestName.value = data.bestRecordName;
  } else {
    document.getElementById('no_record').checked = true;
    noRecordCheck(changeBestHour, changeBestMin, changeBestSec, changeBestDate, changeBestName);
  }
}

function updateFileName() {
  if (fileInput.files && fileInput.files.length > 0) {
    fileName.textContent = fileInput.files[0].name;
  } else {
    fileName.textContent = '파일을 선택하세요...';
  }
}

// 개인정보 조회 업로드
function updateUserInfo(data) {
  setUpdateText(username, data.name);
  setUpdateText(userenname, data.ename);
  setUpdateText(birth, data.birth);
  setUpdateText(particle, uuid ? `${data.course} 멤버십` : data.course);
  setUpdateText(startGroup, data.startGroup ? data.startGroup : '미정');
  setUpdateText(particleNumber, data.baebun ? data.baebun : '미정');
  // eslint-disable-next-line no-nested-ternary
  setUpdateText(gender, data.gender === 'M' ? '남성' : data.gender === 'F' ? '여성' : '');
  setUpdateText(size, data.giftName);
  setUpdateText(blood, data.blood);
  setUpdateText(email, data.email);
  setUpdateText(document.getElementById('address'), `[${data.post}] ${data.address1} ${data.address2}`);
  setUpdateText(phoneNumber, data.ptel);
  setUpdateText(emerNumber, data.etel);
  setUpdateText(freecode, data.codeNumber);
  setUpdateText(document.getElementById('choMember'), data.chosunEmail ? '인증완료' : '-');
  setUpdateText(bestRecord, data.bestRecord, '00:00:00');
  setUpdateText(bestRecordDate, data.bestRecordDate);
  setUpdateText(bestRecordName, data.bestRecordName);
  setUpdateText(document.getElementById('deari_info'), data.parentInfo ? `*법정 대리인 인증이 완료되었습니다. (${data.parentInfo.agrDate.substring(0, 8)})` : '', '');

  if (data.subscribeEmail) {
    subsMailForm.style.display = 'block';
    setUpdateText(subsMail, data.subscribeEmail);
  }
}

// 개인정보 조회 데이터 입력
function updateUI(data) {
  updateUserInfo(data);
  updateNationality(data);
  updatePayment(data, price, cancelPrice, ispayment, realPrice);
  updateSubscription(data);

  // 카드 영수증 display/hide
  infoObj.data.data.payState === '1' && !infoObj.data.data.codeNumber ? payReceipt.style.display = 'inline-flex' : payReceipt.style.display = 'none';
  // 결제 버튼 기간 설정
  const isPayPeriod = payPeriod();
  payPayment.style.display = isPayPeriod ? 'inline-flex' : 'none';

  if (!infoObj.data.data.subscribeEmail && !infoObj.data.data.uuid) {
    paySubscribe.style.display = isPayPeriod ? 'inline-flex' : 'none';
  }
  document.getElementById('browserText').style.display = isPayPeriod ? 'inline-flex' : 'none';
  // 무료구독 동의 데이터
  subsYn = data.subscribeYn;

  toggleDisplay('.confirm_info', false);
  toggleDisplay('.confirm_history', true);
}

// 핸드폰 번호 & 비상연락망 비교
function phoneCheckHandler(main, emergency) {
  return () => {
    isInput(nationDivide, main);
    checkLength(nationDivide, main, 8);
    if (main.value && emergency.value && main.value === emergency.value) {
      alert('핸드폰 번호와 비상연락망은 다르게 입력해주세요.');
      // eslint-disable-next-line no-param-reassign
      main.value = '';
    }
  };
}

function checkImageExists(url) {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => resolve(true);
    img.onerror = () => resolve(false);
    img.src = url;
  });
}

// 정보수정하기 데이터 노출
function updateFormFields(data) {
  setUpdateValue(changeUsername, data.name);
  setUpdateValue(changeUserEnName, data.ename);
  setUpdateValue(document.getElementById('change_nationality'), data.nation);
  setUpdateValue(document.getElementById('change_year'), data.birth.substring(0, 4));
  setUpdateValue(document.getElementById('change_month'), data.birth.substring(4, 6));
  setUpdateValue(document.getElementById('change_day'), data.birth.substring(6, 8));
  setUpdateValue(changeBlood, data.blood);
  setUpdateValue(changePost, data.post);
  setUpdateValue(changeAddressKakao, data.address1);
  setUpdateValue(changeAddressDetail, data.address2);
  setUpdateValue(changePhoneNumber, data.ptel);
  setUpdateValue(changeEmerNumber, data.etel);
  setUpdateValue(changeSubscribe, data.subscribe || 'empty');

  document.getElementById('change_gender').innerText = data.gender === 'M' ? '남성' : '여성';
  document.getElementById('change_particle').innerHTML = `<option value='${data.courseSeq}'>${uuid ? `${data.course} 멤버십` : data.course}</option>`;
  document.getElementById('change_size').innerHTML = `<option value='${data.giftSeq}'>${data.giftName}</option>`;

  updateEmailFields(changeEmail, changeEmailBehind, changeEmailBehindSelect);
  updateBloodType(data, changeBlood, changeBloodEtc);

  changeBloodConf = data.blood;

  const isNation = data.nation === 'South Korea';
  toggleDisplay('#race_form', !isNation);
  if (!isNation) {
    const pickupAddressChecked = data.receiveType === 'C';
    changePickupAddress.checked = pickupAddressChecked;
    document.getElementById('change_pickup_day').checked = !pickupAddressChecked;
  }

  updateBestRecord(data);

  if (infoObj.data.data.codeNumber) {
    toggleDisplay('#free_code_text2', false);
    setUpdateValue(document.getElementById('change_free_code'), infoObj.data.data.codeNumber);
  } else {
    toggleDisplay('#change_free_code', false);
    toggleDisplay('#free_code_text', false);
    toggleDisplay('#free_code_text2', true);
  }

  toggleDisplay('#change_modal_text', !data.chosunEmail);
  document.getElementById('changeModalConfirm').textContent = data.chosunEmail ? '인증완료' : '미인증';

  // 기록 업로드 버튼 기간별 노출
  if (recordPeriod()) {
    bestRecordForm.style.display = 'block';
    document.getElementById('choMemberForm').style.borderBottom = '1px solid #eaeaea';

    checkImageExists(`${LOAD_BASE_URL}/image/${infoObj.data.data.seq}.jpg?nocache=${Date.now()}`)
      .then((exists) => {
        if (exists) {
          document.getElementById('recordUser').innerHTML = `
          <a href="${LOAD_BASE_URL}/image/${infoObj.data.data.seq}.jpg?nocache=${Date.now()}" target="_blank" class="mgr-sm-3 blue_type" style="font-size: 16px; line-height: 1.5;">제출완료된 기록증 확인</a>
          <button type="button" class="button_type2 btn_initial" id="btn_record"
              onclick="confirmFn.fileUpload()">기록 업로드</button>
      `;
        } else {
          document.getElementById('recordUser').innerHTML = `
        <button type="button" class="button_type2 btn_initial" id="btn_record"
            onclick="confirmFn.fileUpload()">기록 업로드</button>
      `;
        }
      });
  } else {
    bestRecordForm.style.display = 'none';
    document.getElementById('choMemberForm').style.borderBottom = '0';
  }

  updatePayment(data, document.getElementById('change_price'), cancelPrice, changeIspayment, document.getElementById('change_realPrice'));
  changePayReceipt.style.display = data.payState === '0' || data.codeNumber ? 'none' : 'inline-flex';

  const forms = [
    'subscribe_form',
    'free_code_form',
    'choMemberForm',
  ];

  const display = data.uuid ? 'none' : 'block';

  forms.forEach((id) => {
    document.getElementById(id).style.display = display;
  });
}

// 목표/최고 기록 유효성 체크
function bestRecordCheck(value1, value2, value3, value4, value5) {
  return bestRecordValiChk(value1, value2, value3, value4, value5);
}

// 웹 결제 주문정보 저장 and 임시데이터 저장
function saveOrder() {
  const jsonObject = {
    applySeq: infoObj.data.data.seq,
  };

  if (uuid) {
    const isCheck = document.getElementById('pointCheck').checked;
    jsonObject.point = isCheck ? 5000 : 0;
  }

  return uuid
    ? api.setEarlyOrder(jsonObject)
    : api.setSaveOrder(jsonObject);
}

async function renderPointInfo(data, form, isChange) {
  if (!uuid) return;

  const { payState, price: originalPrice, point } = data;
  const USE_POINT_VALUE = 5000;

  let realPoint = 0;

  try {
    const remainPoint = await api.getPointData(uuid);
    realPoint = remainPoint.data.balPoint;
  } catch (error) {
    console.error('포인트 정보를 불러오는 중 오류 발생:', error);
  }

  const renderUsedInfo = (x) => {
    form.innerHTML = `
      <div class="title_area">
        <span class="text01">포인트 정보</span>
      </div>
      <div class="form_detail">
        <span class="form_text">조선멤버십 보유 포인트</span>
        <div class="flex_box mg-bt-sm-4" style="display: inline-flex; align-items: start; flex-direction: column; gap: 24px;">
          <span class="confirm_text_type">${calcPrice(x)} 포인트</span>
          <span class="confirm_text_type usePoint" style="font-size: 16px; line-height: 1.5; color: #707070;"></span>
        </div>
      </div>
    `;

    document.querySelectorAll('.usePoint').forEach((el) => {
      el.textContent = point === USE_POINT_VALUE
        ? `${calcPrice(USE_POINT_VALUE)}포인트 사용 완료`
        : `${calcPrice(USE_POINT_VALUE)}포인트 미 사용`;
    });
  };

  if (!isChange) {
    // eslint-disable-next-line consistent-return
    return renderUsedInfo(realPoint);
  }

  // 결제 전 상태일 때 (포인트 사용 가능)
  if (payState === '0') {
    form.innerHTML = `
    <div class="title_area">
      <span class="text01">포인트 정보</span>
    </div>
    <div class="form_detail">
      <span class="form_text">조선멤버십 보유 포인트</span>
      <div class="flex_box mg-bt-sm-4" style="display: inline-flex; align-items: start; flex-direction: column; gap: 24px;">
        <span class="confirm_text_type mgr-sm-4" id="point">${calcPrice(realPoint)} 포인트</span>
      </div>
      <div class="flex_box detail_info2 mg-bt-ssm-8">
        <input type="checkbox" id="pointCheck" class="input_type3" style="margin-top : 0">
        <label for="pointCheck">5,000포인트 사용</label>
      </div>
      <span class="detail_info2">*5,000 포인트 이상 보유 시 사용할 수 있어요.</span>
    </div>
  `;

    // 체크박스 이벤트 처리
    const pointCheck = document.getElementById('pointCheck');
    const priceElement = document.getElementById('price');
    const priceOriginal = document.getElementById('priceOriginal');

    if (realPoint < USE_POINT_VALUE) {
      pointCheck.disabled = true;
      const pointLabel = document.querySelector('label[for="pointCheck"]');
      pointLabel.style.color = '#999';
    }

    pointCheck.addEventListener('change', () => {
      const newPrice = pointCheck.checked && originalPrice > 0
        ? originalPrice - USE_POINT_VALUE
        : originalPrice;

      priceElement.innerText = `${calcPrice(newPrice)} 원`;

      if (pointCheck.checked) {
        priceOriginal.style.display = 'inline-flex';
        priceOriginal.innerText = `${calcPrice(originalPrice)} 원`;
      } else {
        priceOriginal.style.display = 'none';
      }
    });
  } else {
    renderUsedInfo(realPoint);
  }
}

function saveBusOrder() {
  const jsonObject = {
    applySeq: infoObj.data.data.seq,
    name: infoObj.data.data.name,
    email: infoObj.data.data.email,
    tel: infoObj.data.data.ptel,
    gopaymethod: 'Card',
    startPoint: document.getElementById('bus_place').value,
    count: 1,
    price: 25000,
  };

  return api.setSaveBusOrder(jsonObject);
}

// 웹 결제 창 호출
// eslint-disable-next-line consistent-return
const webOrder = async () => {
  let oid = '';
  oid = await saveOrder();
  if (oid !== 'error') {
    api.setWebOrder(oid);
  }
};

const webBusOrder = async () => {
  let oid = '';
  oid = await saveBusOrder();
  if (oid !== 'error') {
    api.setWebBusOrder(oid);
  }
};

// 모바일 결제 주문정보 저장 and 임시데이터 저장
async function saveMobileOrder() {
  const jsonObject = {
    applySeq: infoObj.data.data.seq,
  };

  if (uuid) {
    const isCheck = document.getElementById('pointCheck').checked;
    jsonObject.point = isCheck ? 5000 : 0;
  }

  return uuid
    ? api.setEarlyMobileOrder(jsonObject)
    : api.setSaveMobileOrder(jsonObject);
}

async function saveMobileBusOrder() {
  const jsonObject = {
    applySeq: infoObj.data.data.seq,
    name: infoObj.data.data.name,
    email: infoObj.data.data.email,
    tel: infoObj.data.data.ptel,
    gopaymethod: 'Card',
    startPoint: document.getElementById('bus_place').value,
    count: 1,
    price: 25000,
  };

  const result = await api.setSaveMobileBusOrder(jsonObject);
  return result;
}

// 모바일 결제 창 호출
const mobileOrder = async () => {
  let oid = '';
  oid = await saveMobileOrder();
  if (oid !== 'error') {
    document.querySelector('#payment_popup').href = `${API_BASE_URL}/common/mobile-open?oid=${oid}`;
    document.getElementById('payment_popup').click();
    // window.open(url + "/mobile-open?oid=" + oid, "결제창");
  }
  // window.open(url + "/mobile-open?oid=" + oid, "결제창");
};

const mobileBusOrder = async () => {
  let oid = '';
  oid = await saveMobileBusOrder();
  if (oid !== 'error') {
    document.querySelector('#payment_popup').href = `${API_BASE_URL}/common/mobile-bus-open?oid=${oid}`;
    document.getElementById('payment_popup').click();
  }
};

// 결제하기 버튼 클릭
// eslint-disable-next-line import/prefer-default-export
function requestOrder() {
  if (Mobile() !== 'Mobile') { // 웹 결제
    webOrder();
  } else { // 모바일 결제
    mobileOrder();
  }
}

function requestBusOrder() {
  if (Mobile() !== 'Mobile') { // 웹 결제
    webBusOrder();
  } else { // 모바일 결제
    mobileBusOrder();
  }
}

function handleExpire() {
  alert('결제 기간이 아닙니다.');
  document.getElementById('browserText').style.display = 'none';
  payPayment.style.display = 'none';
  paySubscribe.style.display = 'none';
}

// payment.js end

const confirmFn = {
  // email 뒷자리 select box 값 넣기
  setEmail(value) {
    emailChange(document.getElementById('changeEmailBehind'), value);
  },

  subsCloseModal() {
    subsModal.style.display = 'none';
    document.body.classList.remove('modal-open');
  },

  closeModal() {
    cancelModal.style.display = 'none';
    document.body.classList.remove('modal-open');
  },

  busCloseModal() {
    busModal.style.display = 'none';
    document.body.classList.remove('modal-open');
  },

  confirmPart() {
    document.querySelector('.confirm_history').style.display = 'block';
    document.querySelector('.confirm_change').style.display = 'none';
    document.querySelector('.bus_part_info').style.display = 'none';
    document.querySelector('.bus_confirm').style.display = 'none';
  },

  preActionPay() {
    document.querySelector('.bus_part_info').style.display = 'block';
    document.querySelector('.bus_pay').style.display = 'none';
  },

  // eslint-disable-next-line consistent-return
  busReserve() {
    // 버스 신청 기간도 아니고 결제도 안했을 경우 - 알럿 문구 : 버스 신청 기간이 아닙니다.
    if (!(busPeriodStart < serverDate() && busPeriodEnd > serverDate()) && !(infoObj.data.data.payState === '1')) {
      alert(errorMessage.bus.finish);
      return;
    }

    // 버스 신청 기간인데 결제를 안했을 경우 - 알럿 문구 : 결제 후 신청 가능합니다.
    if ((busPeriodStart < serverDate() && busPeriodEnd > serverDate()) && !(infoObj.data.data.payState === '1')) {
      // alert(errorMessage.bus.pay);
      alert(errorMessage.bus.finish);
      return;
    }

    if (!infoObj.data.data.busResponse) {
      alert(errorMessage.bus.finish);
      return;
    }

    document.querySelectorAll('.confirm_tab').forEach((el) => {
      el.style.backgroundColor = '#fff';
      el.style.color = '#000';
    });

    document.querySelectorAll('.bus_tab').forEach((el) => {
      el.style.backgroundColor = '#000';
      el.style.color = '#fff';
    });

    // 내용 영역 숨김 처리
    document.querySelectorAll('.confirm_history').forEach((el) => {
      el.style.display = 'none';
    });

    document.querySelectorAll('.confirm_change').forEach((el) => {
      el.style.display = 'none';
    });

    document.querySelectorAll('.bus_confirm').forEach((el) => {
      el.style.display = 'block';
    });

    document.getElementById('bus_name').innerText = infoObj.data.data.name;
    document.getElementById('bus_birth').innerText = infoObj.data.data.birth;
    document.getElementById('bus_start').innerText = infoObj.data.data.busResponse.startPoint;
    document.getElementById('bus_ticket_price').innerText = `${calcPrice(infoObj.data.data.busResponse.price)}원`;
    document.getElementById('bus_ticket_real_price').innerText = `${calcPrice(infoObj.data.data.busResponse.price)}원`;
    document.getElementById('bus_ispayment').innerText = '결제완료';
    document.getElementById('bus_cancel_price').innerText = `${calcPrice(infoObj.data.data.busResponse.price)}원`;
  },

  busPay() {
    if (!document.getElementById('bus_place').value) {
      alert(errorMessage.bus.start);
    } else {
      document.querySelector('.bus_part_info').style.display = 'none';
      document.querySelector('.bus_pay').style.display = 'block';
      document.getElementById('bus_res_price').innerText = '25,000원';
      document.getElementById('bus_res_real_price').innerText = '25,000원';
    }
  },

  busRefund() {
    if (getRallyClose()) {
      if (serverDate() < confirmEndDate) {
        busModal.style.display = 'block';
        document.body.classList.add('modal-open');
      } else {
        alert(errorMessage.confirm.change.cancel);
      }
    } else {
      alert(errorMessage.etc);
    }
  },

  searchPw() {
    if (name.value && year.value && month.value && day.value) {
      api.searchPasswordApi(getRallyClose().seq, name.value, year.value + month.value + day.value);
    } else {
      alert(errorMessage.apply.input.info);
    }
  },

  // 참가 신청 조회
  async infoNext() {
    const setBirth = `${year.value}${month.value}${day.value}`;

    // 기본 입력값 검증
    if (!name.value || !year.value || !month.value || !day.value || !password.value) {
      alert(errorMessage.confirm.fix);
      return;
    }

    const result = await api.infoMember(getRallyClose().seq, name.value, setBirth, password.value);
    if (result) infoObj = result;

    const data = infoObj?.data?.data;
    if (!data) return;

    groupSeq = data.groupInfo?.seq || 1;
    // uuid 값 부여 (얼리버드 회원 여부 확인)
    uuid = data.uuid;

    if (infoObj.data.data) {
      updateUI(infoObj.data.data);
    }

    // 멤버십 정보(uuid)가 없을 경우 포인트 정보 미노출, 관련 폼 미노출
    if (uuid && (serverDate() < payEarlyFullEnd) && (serverDate() > payEarlyFullStart)) { await renderPointInfo(data, pointForm, true); }

    const forms = [
      'earlyhiddenForm1',
      'earlyhiddenForm2',
      'earlyhiddenForm3',
    ];

    const display = uuid ? 'none' : 'block';

    forms.forEach((id) => {
      document.getElementById(id).style.display = display;
    });
  },

  // 독자 인증 모달 활성화
  subsCheck() {
    subsModal.style.display = 'block';
    document.body.classList.add('modal-open');
  },

  // 환불 신청 모달 활성화
  // eslint-disable-next-line consistent-return
  particleCancel() {
    if (getRallyClose()) {
      if (infoObj.data.data.busResponse) {
        alert(errorMessage.bus.refund);
        return false;
      }

      if (serverDate() < confirmEndDate) {
        confirmModal.style.display = 'block';
        document.body.classList.add('modal-open');
      } else {
        alert(errorMessage.confirm.change.cancel);
      }
    } else {
      alert(errorMessage.etc);
    }
  },

  // 정보 수정하기
  async particleInfoChange() {
    if (getRallyClose()) {
      if (serverDate() < confirmEndDate) {
        toggleDisplay('.confirm_change', true);
        toggleDisplay('.confirm_history', false);

        if (infoObj.data.data) {
          updateFormFields(infoObj.data.data);
        }

        // uuid 값 없을 경우 포인트 정보 미노출
        if (uuid && (serverDate() < payEarlyFullEnd) && (serverDate() > payEarlyFullStart)) { await renderPointInfo(infoObj.data.data, changePointForm, false); }
      } else {
        alert(errorMessage.confirm.change.finish);
      }
    } else {
      alert(errorMessage.apply.finish.apply);
    }
  },

  maxLengthCheck(data) {
    if (data.value.length > data.maxLength) {
      // eslint-disable-next-line no-param-reassign
      data.value = data.value.slice(0, data.maxLength);
    }
  },

  fileUpload() {
    document.getElementById('btn_record').disabled = true;
    const dateNow = serverDate();
    if (!(dateNow >= recordFirstStart && dateNow <= recordFirstEnd) && !(dateNow >= recordSecondStart && dateNow <= recordSecondEnd)) {
      alert('기록증 제출 기간이 아닙니다.');
      bestRecordForm.style.display = 'none';
      document.getElementById('choMemberForm').style.borderBottom = '0';
      return;
    }

    uploadModal.style.display = 'block';
    document.body.classList.add('modal-open');

    setTimeout(() => {
      document.getElementById('btn_record').disabled = false;
    }, 1500);
  },

  uploadClose() {
    fileInput.value = '';
    fileName.textContent = '파일을 선택하세요...';

    formdata = new FormData();

    uploadModal.style.display = 'none';
    document.body.classList.remove('modal-open');
  },

  upload() {
    const filelist = fileInput.files[0];
    formdata = new FormData();
    fileName.textContent = '파일을 선택하세요...';

    if (!(serverDate() >= recordFirstStart && serverDate() <= recordFirstEnd) && !(serverDate() >= recordSecondStart && serverDate() <= recordSecondEnd)) {
      alert('기록증 제출 기간이 아닙니다.');
      return;
    }

    if (!filelist) {
      alert('파일을 입력해주세요.');
      return;
    }

    const uploadxhr = new XMLHttpRequest();

    const actionUrl = `${API_BASE_URL}/common/send/record-file`;

    formdata.enctype = 'multipart/form-data';
    formdata.method = 'post';
    formdata.action = actionUrl;

    formdata.append('applySeq', infoObj.data.data.seq);
    formdata.append('name', infoObj.data.data.name);
    formdata.append('birth', infoObj.data.data.birth);
    formdata.append('rallyType', 'C');

    const { files } = document.getElementById('file');

    for (let i = 0; i < files.length; i++) {
      formdata.append('file', files[i]);
    }

    uploadxhr.open('POST', actionUrl, true);
    // eslint-disable-next-line func-names
    uploadxhr.onload = function () {
      if (uploadxhr.status === 200) {
        formdata.delete('file');
        fileInput.value = null;
        alert('업로드가 완료되었습니다.');

        uploadModal.style.display = 'none';
        document.body.classList.remove('modal-open');

        checkImageExists(`${LOAD_BASE_URL}/image/${infoObj.data.data.seq}.jpg?nocache=${Date.now()}`)
          .then((exists) => {
            if (exists) {
              document.getElementById('recordUser').innerHTML = `
          <a href="${LOAD_BASE_URL}/image/${infoObj.data.data.seq}.jpg?nocache=${Date.now()}" target="_blank"  style="font-size: 16px; line-height: 1.5;" class="mgr-sm-3 blue_type">제출완료된 기록증 확인</a>
          <button type="button" class="button_type2 btn_initial" id="btn_record"
              onclick="confirmFn.fileUpload()">기록 업로드</button>
        `;
            } else {
              document.getElementById('recordUser').innerHTML = `
          <button type="button" class="button_type2 btn_initial" id="btn_record"
              onclick="confirmFn.fileUpload()">기록 업로드</button>
        `;
            }
          });
      } else {
        const { data } = JSON.parse(uploadxhr.responseText);
        alert(data);
      }
    };

    uploadxhr.send(formdata);
  },

  // 개인정보수정하기 적용
  async changeInformation() {
    if (changePassword.value) {
      checkLength(nationDivide, changePassword, 8);

      if (!(changePassword.value === changePasswordConf.value)) {
        alert(errorMessage.apply.password);

        return;
      }

      dataCheckPw = changePassword.value;
    } else {
      dataCheckPw = null;
    }

    if (changeBlood.value === 'etc') {
      changeBloodEtc.addEventListener('change', () => {
        isInput(nationDivide, changeBloodEtc);
      });
      changeBloodConf = changeBloodEtc.value;
    } else {
      changeBloodConf = changeBlood.value;
    }

    if (infoObj.data.data.nation !== 'South Korea') {
      receiveTypeEn = document.querySelector('input[type="radio"][name="pickup"]:checked')?.value || '';
    }

    const requiredFields = [
      changeEmail, changeEmailBehind, changeAddressKakao, changePhoneNumber, changeEmerNumber, changeBlood, changeSubscribe,
    ];

    if (changeBlood.value === 'etc') requiredFields.push(changeBloodEtc);
    checkRequired(nationDivide, requiredFields);

    if (validationArr.length > 0) {
      document.getElementById(validationArr[0]).focus();
    } else {
      setValidationArr();

      const jsonObject = {
        seq: infoObj.data.data.seq,
        groupSeq,
        eName: changeUserEnName.value ? changeUserEnName.value.trim() : '',
        password: !dataCheckPw ? dataCheckPw : dataCheckPw.trim(),
        currentPassword: password.value,
        blood: changeBloodConf,
        email: `${changeEmail.value.trim()}@${changeEmailBehind.value.trim()}`,
        post: changePost.value,
        address1: changeAddressKakao.value,
        address2: changeAddressDetail.value,
        pTel: changePhoneNumber.value,
        eTel: changeEmerNumber.value,
        bestRecord: `${changeBestHour.value}:${changeBestMin.value}:${changeBestSec.value}`,
        subscribe: changeSubscribe.value,
        subscribeYn: subsYn,
        receiveType: receiveTypeEn,
        bestRecordDate: '', // 초기값 설정
        bestRecordName: '', // 초기값 설정
        targetRecord: '00:00:00', // 초기값 설정
      };

      await api.changepartInfo(jsonObject);
    }
  },
};

export default confirmFn;

window.confirmFn = confirmFn;

document.addEventListener('DOMContentLoaded', async () => {
  try {
    const mainData = await api.mainLoad();
    setCookie('rallyGnbDate', mainData, 1);
    setRallyClose(mainData);
  } catch (error) {
    console.error('mainLoad 실패:', error);
  }

  birthList();

  setCookie('divide_json_data', nationDivide, 1);

  changeBlood.addEventListener('change', () => {
    isInput(nationDivide, changeBlood);
    if (changeBlood.value === 'etc') {
      changeBloodEtc.disabled = false;
    } else {
      changeBloodEtc.value = '';
      changeBloodEtc.disabled = true;
      showSucces(changeBlood);
      if (changeBlood.value) showSucces(changeBloodEtc);
    }

    changeBloodConf = changeBlood.value;
  });

  changeBloodEtc.addEventListener('change', () => {
    isInput(nationDivide, changeBloodEtc);
  });
  changePhoneNumber.addEventListener('change', () => {
    isInput(nationDivide, changePhoneNumber);
    checkLength(nationDivide, changePhoneNumber, 11);
  });
  changeEmerNumber.addEventListener('change', () => {
    isInput(nationDivide, changeEmerNumber);
    checkLength(nationDivide, changeEmerNumber, 11);
  });
  changePassword.addEventListener('change', () => {
    isInput(nationDivide, changePassword);
    checkLength(nationDivide, changePassword, 8);
    checkPasswordConf(nationDivide, changePasswordConf, changePassword);
  });
  changePasswordConf.addEventListener('change', () => {
    isInput(nationDivide, changePassword);
    checkLength(nationDivide, changePassword, 8);
    checkPasswordConf(nationDivide, changePassword, changePasswordConf);
  });
  changeEmail.addEventListener('change', () => {
    isInput(nationDivide, changeEmail);
    checkEmail(nationDivide, changeEmail, changeEmailBehind);
  });
  changeEmailBehind.addEventListener('change', () => {
    isInput(nationDivide, changeEmailBehind);
    checkEmail(nationDivide, changeEmail, changeEmailBehind);
  });
  changeEmailBehindSelect.addEventListener('change', () => {
    checkEmail(nationDivide, changeEmail, changeEmailBehind);
    changeEmailBehind.disabled = !!changeEmailBehindSelect.value;
    if (changeEmailBehindSelect.value) showSucces(changeEmailBehind);
  });
  changeSubscribe.addEventListener('change', () => {
    isInput(nationDivide, changeSubscribe);
  });
  file.addEventListener('change', () => {
    updateFileName();
    validateFile();
  });

  addChangeListener(changePhoneNumber, phoneCheckHandler(changePhoneNumber, changeEmerNumber));
  addChangeListener(changeEmerNumber, phoneCheckHandler(changeEmerNumber, changePhoneNumber));

  changeBestHour.addEventListener('change', () => {
    bestRecordCheck(changeBestHour, changeBestMin, changeBestSec, changeBestDate, changeBestName);
  });

  changeBestMin.addEventListener('change', () => {
    bestRecordCheck(changeBestHour, changeBestMin, changeBestSec, changeBestDate, changeBestName);
  });

  changeBestSec.addEventListener('change', () => {
    bestRecordCheck(changeBestHour, changeBestMin, changeBestSec, changeBestDate, changeBestName);
  });

  changeBestDate.addEventListener('change', () => {
    bestRecordCheck(changeBestHour, changeBestMin, changeBestSec, changeBestDate, changeBestName);
  });

  changeBestName.addEventListener('change', () => {
    bestRecordCheck(changeBestHour, changeBestMin, changeBestSec, changeBestDate, changeBestName);
  });

  noRecord.addEventListener('change', () => {
    noRecordCheck(changeBestHour, changeBestMin, changeBestSec, changeBestDate, changeBestName);
  });

  const handleKakaoClick = _.throttle(() => {
    setupAddressMapKakao(nationDivide, changePost, changeAddressKakao, changeAddressDetail);
  }, 2000);

  // busCount.addEventListener('change', () => {
  //   busCountPay.innerText = `${calcPrice(busCount.value * 25000)}원`;
  // });

  // 참가신청 취소
  const handleRefundClick = _.throttle(async () => {
    if (confirmEndDate < serverDate()) {
      alert('환불 기간이 아닙니다.');

      return;
    }

    const jsonObject = {
      applySeq: infoObj.data.data.seq,
      type: 'Refund',
      oid: infoObj.data.data.oid,
      payMethod: infoObj.data.data.payMethod,
      price: infoObj.data.data.price,
      password: password.value,
    };

    await api.setApplyCancel(jsonObject);
  }, 2000);

  // 버스 취소
  const handleBusRefundClick = _.throttle(async () => {
    if (confirmEndDate < serverDate()) {
      alert('환불 기간이 아닙니다.');

      return;
    }

    const jsonObject = {
      applySeq: infoObj.data.data.seq,
      oid: infoObj.data.data.busResponse.oid,
    };

    await api.setBusCancel(jsonObject);
  }, 2000);

  const handleSubsClick = _.throttle(async () => {
    if (infoObj.data.data.seq) {
      const seqObject = Object.values(courseSeqArr).find((item) => item.seq === infoObj.data.data.courseSeq);

      // 코스 시퀀스 자체가 할인된 케이스
      if (infoObj.data.data.courseSeq === 2 || infoObj.data.data.courseSeq === 6) {
        alert('이미 할인이 적용되었습니다.');
        return;
      }

      // 이미 할인된 가격인지 확인
      if (infoObj.data.data.price !== seqObject.price) {
        alert('이미 할인이 적용되었습니다.');
        return;
      }

      const result = await api.checkSubscription({
        applySeq: infoObj.data.data.seq,
        email: document.getElementById('subs-id').value,
      });

      if (result) {
        paySubscribe.style.display = 'none';
        subsModal.style.display = 'none';
        document.body.classList.remove('modal-open');
        const originalPrice = infoObj.data.data.price;
        const discountedPrice = applyDiscount(originalPrice);
        infoObj.data.data.price = discountedPrice;
        const discountPriceText = calcPrice(discountedPrice);
        price.innerText = `${discountPriceText} 원`;
        subsMailForm.style.display = 'block';
        setUpdateText(subsMail, document.getElementById('subs-id').value);
      } else {
        document.getElementById('subs-id').value = '';
      }
    }
  }, 2000);

  const paymentClick = _.throttle(async () => {
    const dateNow = serverDate();
    const { courseSeq } = infoObj.data.data;
    const isEarly = !!infoObj.data.data.uuid;

    if (infoObj.data.data.uuid && (!infoObj.data.data.membershipYn || infoObj.data.data.membershipYn === 'N')) {
      alert('조선멤버십 회원이 아닌 경우 결제를 할 수 없습니다. 멤버십 재 가입 후 다시 이용해주세요.');
      return;
    }

    const isFullCourse = courseSeq === 1 || courseSeq === 2;
    const isTenCourse = courseSeq === 5 || courseSeq === 6;

    const isOutOfFullPeriod = isEarly
      ? dateNow > payEarlyFullEnd
      : dateNow > payFullEnd;

    const isOutOfTenPeriod = isEarly
      ? dateNow > payEarlyTenEnd
      : dateNow > payTenEnd;

    if (isFullCourse && isOutOfFullPeriod) {
      handleExpire();
      return;
    }

    if (isTenCourse && isOutOfTenPeriod) {
      handleExpire();
      return;
    }

    requestOrder();
  }, 2000);

  const busPaymentClick = _.throttle(async () => {
    const dateNow = serverDate();
    if (dateNow < busPeriodStart || dateNow > busPeriodEnd) {
      alert('결제 기간이 아닙니다.');
      window.location.href = '../index.html';
      return;
    }

    requestBusOrder();
  }, 2000);

  kakao.addEventListener('click', handleKakaoClick);
  refundBtn.addEventListener('click', handleRefundClick);
  busRefundBtn.addEventListener('click', handleBusRefundClick);
  payPayment.addEventListener('click', paymentClick);
  subsBtn.addEventListener('click', handleSubsClick);
  busPayment.addEventListener('click', busPaymentClick);
});
